<template>
    
    <div class="content">
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h3 class="m-0" style="margin-bottom: 10px !important">Pembukuan</h3>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="card mt-0 mb-0 card-stats">
                            <div class="box-horizontal mb-0">
                                <div class="box-menu text-center pointer" @click="link.sisa()">
                                    <i class="material-icons d-block text-warning">people</i>
                                    Uang Di Admin
                                </div>
                                <div class="box-menu text-center pointer" @click="link.pembukuan()">
                                    <i class="material-icons d-block text-info">list</i>
                                    Semua Pembukuan
                                </div>
                                <div class="box-menu text-center pointer" @click="link.pembayaranbyadmin()">
                                    <i class="material-icons d-block text-success">surfing</i>
                                    Pmbyran By Admin
                                </div>
                                <div class="box-menu text-center pointer" @click="link.rangkuman()">
                                    <i class="material-icons d-block text-warning">spa</i>
                                    Rangkuman Keuangan
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <router-link :to="{ name: 'pembukuan-pengeluaran-tambah'}"  class="btn btn-info m-0 mt-4 mb-4" >Tambah Pembukuan</router-link>
                
                <div class="box-horizontal m-0">
                    <h4 class="m-0 flex-1" style="margin-bottom: 10px !important">Pemasukkan</h4>
                    <h4 class="text-success">{{myGlobal.ribu(data.totalMasuk)}}</h4>
                </div>

                <div class="row col-md-12">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Transaksi Cash</p>
                                <h3 class="card-title text-success">{{myGlobal.ribu(data.transaksiCash)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-secondary pointer m-0"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Transaksi Online</p>
                                <h3 class="card-title text-success">{{myGlobal.ribu(data.transaksiOnline)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-secondary pointer m-0"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Pemasukkan Lain-lain</p>
                                <h3 class="card-title text-success">{{myGlobal.ribu(data.transaksiLain)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('masuklain')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-horizontal m-0">
                    <h4 class="m-0 flex-1" style="margin-bottom: 10px !important">Pengeluaran</h4>
                    <h4 class="text-danger">{{myGlobal.ribu(data.totalKeluar)}}</h4>
                </div>
                <div class="row col-md-12">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Gaji Karyawan</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.gaji)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('gaji')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Pasang Baru</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.pasang)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('baru')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Perbaikan Alat</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.alat)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('alat')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Bandwith</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.bandwith)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('bandwith')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Bayar Kang Tagih</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.kangtagih)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('kangtagih')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Bayar Listrik / PDAM / Pulsa</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.listrik)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('listrik')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Bayar Marketing</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.marketing)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('marketing')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Lain lain</p>
                                <h3 class="card-title text-danger">{{myGlobal.ribu(data.lain)}}</h3>
                            </div>
                            <div class="card-footer text-right">
                                <p class="text-info pointer m-0" @click="link.detail('')"> Detail >></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-horizontal m-0">
                    <h4 class="m-0 flex-1" style="margin-bottom: 10px !important">Total Pendapatan</h4>
                </div>
                <div class="row col-md-12">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Total Pemasukkan</p>
                                <h3 class="card-title text-success mb-2">{{myGlobal.ribu(data.totalMasuk)}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Total Pengeluaran</p>
                                <h3 class="card-title text-danger mb-2">{{myGlobal.ribu(data.totalKeluar)}}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="card mt-0 card-stats">
                            <div class="card-header card-header-success card-header-icon text-left">
                                <p class="card-category mt-2">Pendapatan</p>
                                <h3 class="card-title text-info mb-2">{{myGlobal.ribu(data.pendapatan)}}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import router from '@/router'

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      filtered: '',

      bulanNama: '', bulan: '',tahun: '',
      totalAll: 0,
      
      transaksiCash: 0,
      transaksiOnline: 0,
      transaksiLain: 0,
      totalMasuk: 0,

      // pengeluaran
      gaji: 0,
      pasang: 0,
      alat: 0,
      bandwith: 0,
      kangtagih: 0,
      listrik: 0,
      marketing: 0,
      lain: 0,
      totalKeluar: 0,
      // pendapatan
      pendapatan: 0
    })

    const theGet = {
        data: reactive({
          List: [],
        }),
        datae() {
            //console.log(sessionStorage.getItem('admin'));
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                status: 'lunas',
                bulan: data.bulan,
                tahun: data.tahun,
            };
            

            console.log("jancok");
            console.log(JSON.stringify(datax));
        
            var apiUrl = inter.PembukuanDashboard();
            myGlobal.call(datax,apiUrl).then(x => {
                //console.log(JSON.stringify(x));
                
                if (x.status == true) {
                    var datax = x.data;

                    data.transaksiCash = datax.pembayaran;
                    data.transaksiOnline = datax.pembayaranOnline;
                    data.transaksiLain = datax.masuk;
                    data.totalMasuk = parseInt(data.transaksiCash) + parseInt(data.transaksiOnline) + parseInt(data.transaksiLain);
                    // pengeluaran
                    data.gaji = datax.gaji;
                    data.pasang = datax.pasang;
                    data.alat = datax.alat;
                    data.bandwith = datax.bandwith;
                    data.kangtagih = datax.kangtagih;
                    data.listrik = datax.listrik;
                    data.marketing = datax.marketing;
                    data.lain = datax.lain;
                    data.totalKeluar = datax.total;
                    
                    data.pendapatan = parseInt(data.totalMasuk) - parseInt(data.totalKeluar);
                    
                } else {
                    //alert(x.pesan);
                }
            })
        }
    }
    const link = {
        sisa() {
            router.push({ 
                name: 'pembukuan-sisa'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        pembukuan() {
            router.push({ 
                name: 'pembukuan-pengeluaran'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        pembayaranbyadmin() {
            router.push({ 
                name: 'history-pembayaran'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        rangkuman() {
            router.push({ 
                name: 'pembukuan-rangkuman'
                /*
                params: {
                    data: pax
                } 
                */
            });
        },
        detail(kategori) {

            console.log("halo");

            console.log(myGlobal.isCustom());

            let isCustom = myGlobal.isCustom();
            if (isCustom == null) {
                alert("hehe, maap gan. fitur detail cuma untuk custom ya")
                return false;
            }
            // LANJOT CUSTOM TERNYATA

            router.push({ 
                name: 'pembukuan-pengeluaran',
                params: {
                    kategori: kategori
                } 
            });
        }
    }

    return {
      data, 
      theGet,
      myGlobal,
      link
    }
  },
  mounted () {
    document.title = "Pembukuan";
    this.data.bulan =  myGlobal.getBulan();
    this.data.bulanNama = sessionStorage.getItem('bulanNamaBase');
    this.data.tahun = sessionStorage.getItem('tahunBase');

    this.theGet.datae();
  }
}

/**
 * DETAIL TIAP KATEGORI
 * DETAIL CUSTOM ONLY
 * LINK KAN MENU LAIN LAIN
 */

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 35pt;
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/dashmain.vue